import { AppDispatch } from "redux/store";
import { CallLambda } from "./CallLambda";
import { UploadConfigAction } from "./UploadConfig";
import Model from "redux/classes/Model";
import Config from "redux/classes/Config";
import Job from "redux/classes/Job";
import { setJobs } from "redux/slices/user";
import Session from "redux/classes/Session";

export function RunModelAction(session: Session, config: Config, model: Model) {
    return async (dispatch: AppDispatch) => {
        const jobID = await CreateJobAction(dispatch, session, config, model.alias)
        // jobCreator is a hard prerequisite — modelInitializer will throw a
        // KeyError on `info['jobID']` if we proceed without one. Bail
        // explicitly so the user sees a clear "couldn't create the job"
        // signal instead of a misleading "modelInitializer error" trace.
        if (!jobID) {
            throw new Error("Failed to create job — jobCreator did not return a job ID");
        }

        const payload = JSON.stringify({
            "model": model.alias,
            "jobID": jobID,
            "jobAlias": config.meta.alias,
            "jobDesc": config.meta.description,
            "modelID": model.modelID,
            "launchType": model.launchType
        })

        const response = await dispatch(CallLambda(session, "modelInitializer", payload))

        if (response.status === 200) {
            const jobs = response.data.jobs.map((job: any) => {
                return new Job(
                    job.job_id,
                    job.model_id,
                    job.cust_id,
                    job.user_id,
                    job.alias,
                    job.description,
                    job.job_name,
                    job.result_name,
                    job.task_id,
                    job.job_status,
                    new Date(job.start_time),
                    new Date(job.end_time),
                    new Date(job.schedule_time),
                    job.schedule_type,
                )
            })

            dispatch(setJobs({ jobs: jobs }));
        }
    }
}

const CreateJobAction = async (dispatch: AppDispatch, session: Session, config: Config, modelAlias: string) => {
    let date = new Date()
    let jobID = date.toISOString()

    // Stage the config in S3 first, then point jobCreator at it. Passing the
    // config inline used to push large prompts past CloudFront's WAF body
    // limit (default 8 KB) and the request would 403 before reaching API
    // Gateway. The S3-staged path mirrors how input files have always been
    // handled and keeps the jobCreator request body tiny regardless of how
    // much the user has put into their parameters.
    const configJSON = config.makeJSON();
    const configS3Path = await dispatch(UploadConfigAction(session, modelAlias, jobID, configJSON));

    const payload = JSON.stringify({
        "model": modelAlias,
        "configS3Path": configS3Path,
        "jobID": jobID,
    })

    let response: {status: number, data: any} = await dispatch(CallLambda(session, "jobCreator", payload))

    if (response.status === 200) {
        return jobID
    }
}